// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `pre:not(.MessageContent) {
  overflow: initial;
  max-height: initial;
}

.MessageContent pre {
  border: none;
  border-left: 1px solid white;
  padding-left: 1rem;
  height: fit-content; /* Natural height */
  font-family: monospace; /* Ensure monospace font */
  display: flex;
  flex-grow: 1;
  overflow: visible;
}

.MuiMarkdown > div {
  width: 100%;
}

.Message-streaming .MuiMarkdown ul,
.Message-streaming .MuiMarkdown h1,
.Message-streaming .MuiMarkdown p,
.Message-assistant .MuiMarkdown ul,
.Message-assistant .MuiMarkdown h1,
.Message-assistant .MuiMarkdown p {
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/StyledMarkdown.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB,EAAE,mBAAmB;EACxC,sBAAsB,EAAE,0BAA0B;EAClD,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;EAME,YAAY;AACd","sourcesContent":["pre:not(.MessageContent) {\n  overflow: initial;\n  max-height: initial;\n}\n\n.MessageContent pre {\n  border: none;\n  border-left: 1px solid white;\n  padding-left: 1rem;\n  height: fit-content; /* Natural height */\n  font-family: monospace; /* Ensure monospace font */\n  display: flex;\n  flex-grow: 1;\n  overflow: visible;\n}\n\n.MuiMarkdown > div {\n  width: 100%;\n}\n\n.Message-streaming .MuiMarkdown ul,\n.Message-streaming .MuiMarkdown h1,\n.Message-streaming .MuiMarkdown p,\n.Message-assistant .MuiMarkdown ul,\n.Message-assistant .MuiMarkdown h1,\n.Message-assistant .MuiMarkdown p {\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
